export const formatElapsedTimeHHMMSS = (milliseconds) => {
    if (!milliseconds || milliseconds < 0) return '00:00:00';
    
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const formatElapsedTime = (milliseconds) => {
    if (!milliseconds || milliseconds < 0) return '0s';
    
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    
    const remainingMinutes = minutes % 60;
    const remainingSeconds = seconds % 60;
    
    if (hours > 0) {
        return `${hours}h ${remainingMinutes}m ${remainingSeconds}s`;
    } else if (minutes > 0) {
        return `${minutes}m ${remainingSeconds}s`;
    } else {
        return `${seconds}s`;
    }
};

export const msToSeconds = (milliseconds) => {
    return Math.floor(milliseconds / 1000);
};

export const msToMinutes = (milliseconds) => {
    return Math.floor(milliseconds / 60000);
};

export const formatDuration = (startTime) => {
    if (!startTime) return '00:00:00';
    
    const currentTime = new Date().getTime();
    const durationMs = currentTime - startTime;
    
    const totalSeconds = Math.floor(durationMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const initializeTimer = (storageKey) => {
    const existingStartTime = localStorage.getItem(storageKey);
    
    if (existingStartTime) {
        return parseInt(existingStartTime, 10);
    } else {
        const newStartTime = new Date().getTime();
        localStorage.setItem(storageKey, newStartTime.toString());
        return newStartTime;
    }
};

export const clearTimer = (storageKey, durationStorageKey) => {
    localStorage.removeItem(storageKey);
    if (durationStorageKey) {
        localStorage.removeItem(durationStorageKey);
    }
};
